import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type DropdownSelectorProps = {
    width: number;
};

type DropdownProps = {
    width: number;
};

export const DropdownWrapper = styled.div`
    padding: 6px 0 6px 6px;
    display: flex;
`;

export const DropdownText = styled.p`
    color: ${({ theme }) => theme.colors.neutral900};
    font-size: 13px;
    font-weight: 400;
    white-space: nowrap;
    display: flex;
    align-items: center;
`;

export const DropdownLabel = styled(DropdownText)`
    flex-grow: 1;
    margin-right: 4px;
`;

export const DropdownSelector = styled.div<DropdownSelectorProps>`
    border: 1px solid ${({ theme }) => theme.colors.neutral200};
    position: relative;
    padding: 4px 6px;
    width: ${({ width }) => `${width}px`};
    cursor: pointer;
    &:focus-visible {
        outline: ${({ theme }) => `solid ${theme.colors.primary300}`};
    }
`;

export const Dropdown = styled.ul<DropdownProps>`
    list-style-type: none;
    width: ${({ width }) => `${width + 10}px`};
    padding: 0;
    margin: 0;
    background: rgb(255, 255, 255);
    border-radius: 0px;
    border: 1px solid ${({ theme }) => theme.colors.neutral200};
    box-shadow: 0px 0px 4px 0px rgba(28, 28, 28, 0.2);
    position: absolute;
    z-index: 4;
    text-align: left;
    left: 0px;
    top: calc(100% + 2px);
`;

export const DropdownItem = styled.li`
    color: rgb(28, 28, 28);
    font-size: 13px;
    font-weight: normal;
    height: 20px;
    letter-spacing: 0px;
    line-height: 20px;
    display: flex;
    text-align: left;
    padding: 8px 10px;
    cursor: pointer;
    overflow: hidden;
    &:hover {
        background-color: #f3f8fc;
    }
    &:focus-visible {
        outline: ${({ theme }) => `solid ${theme.colors.primary300}`};
    }
`;

export const DropdownTextSpan = styled.span`
    flex-grow: 1;
`;

export const Icon = styled(FontAwesomeIcon)`
    margin: 0 0 0 4px;
    font-size: 8px;
    justify-self: end;
`;
